export const UPDATE_EVENT_OPENINGS_SHARED_FILTERS =
  'UPDATE_EVENT_OPENINGS_SHARED_FILTERS';

export const UPDATE_ALL_DISTRICTS_EVENTS_FILTERS =
  'UPDATE_ALL_DISTRICTS_EVENTS_FILTERS';

export const SET_SHOW_DISTRICTS_WITHOUT_EVENTS =
  'SET_SHOW_DISTRICTS_WITHOUT_EVENTS';

export const UPDATE_HOST_EVENTS_FILTERS = 'UPDATE_HOST_EVENTS_FILTERS';

export const UPDATE_K12_ADMIN_EVENTS_FILTERS =
  'UPDATE_K12_ADMIN_EVENTS_FILTERS';

export const UPDATE_MEMBER_EVENTS_VIEW_TYPE = 'UPDATE_MEMBER_EVENTS_VIEW_TYPE';

export const UPDATE_MEMBER_EVENT_DRAWER_ID = 'UPDATE_MEMBER_EVENT_DRAWER_ID';

export const UPDATE_STAFF_EVENTS_VIEW_TYPE = 'UPDATE_STAFF_EVENTS_VIEW_TYPE';
export const UPDATE_STAFF_PARTNER_EVENTS_VIEW_TYPE =
  'UPDATE_STAFF_PARTNER_EVENTS_VIEW_TYPE';

export const SET_SCHEDULED_EVENTS_SELECTED_EVENT_ID =
  'SET_SCHEDULED_EVENTS_SELECTED_EVENT_ID';
export const SET_PARTNER_EVENTS_SELECTED_EVENT_ID =
  'SET_PARTNER_EVENTS_SELECTED_EVENT_ID';
